<template>
  <div>
  
  
 <h4 v-if="createForm" slot="header" class="card-title">
    Add New Person To Database
    </h4>
     <h4 v-else slot="header" class="card-title">
     Update Person 
    </h4>
  
 <card class="form-horizontal">
   
    

    <div class="row" style="text-align:left;">
      <label class="col-sm-2 col-form-label">First Name</label>
      <div class="col-sm-7">
        <fg-input type="text"
                  name="first_name"
                  v-validate="modelValidations.first_name"
                  :error="getError('first_name')"
                  v-model="model.first_name">
        </fg-input>
      </div>
      <div class="col-sm-3 label-on-right">
        <code></code>
      </div>
    </div>

    <div class="row">
      <label class="col-sm-2 col-form-label">Last Name</label>
      <div class="col-sm-7">
        <fg-input type="text"
                  name="last_name"
                  v-model="model.last_name"
                  >
        </fg-input>
      </div>
      <div class="col-sm-3 label-on-right">
        <code></code>
      </div>
    </div>
    
    
    <div class="row">
      <label class="col-sm-2 col-form-label">Address</label>
      <div class="col-sm-7">
        <fg-input type="text"
                  name="address_1"
                  v-validate="modelValidations.address_1"
                  :error="getError('address_1')"
                  v-model="model.address_1">
        </fg-input>
      </div>
      <div class="col-sm-3 label-on-right">
        <code></code>
      </div>
    </div>
    
    <div class="row">
      <label class="col-sm-2 col-form-label">Citizenship Type</label>
      <div class="col-sm-7">
        <fg-input>
                  <el-select class="select-primary"
                             size="large"
                             placeholder=""
                             v-model="model.citizenship">
                    <el-option v-for="option in variables.citizenship"
                               class="select-danger"
                               :value="option.value"
                               :label="option.label"
                               :key="option.label">
                    </el-option>
                  </el-select>
        </fg-input>
      </div>
      <div class="col-sm-3 label-on-right">
        <code></code>
      </div>
    </div>

    <div class="row">
      <label class="col-sm-2 col-form-label">Nationality</label>
      <div class="col-sm-7">
        <fg-input>
                  
                  
                    <el-select class="select-primary"
                             size="large"
                             placeholder="Select Country"
                             v-model="model.nationality">
                    <el-option v-for="option in variables.countries"
                               class="select-danger"
                               :value="option.value"
                               :label="option.label"
                               :key="option.label">
                    </el-option>
                  </el-select>
        </fg-input>
        
      </div>
      <div class="col-sm-3 label-on-right">
        <code></code>
      </div>
    </div>
    
     <div class="row">
      <label class="col-sm-2 col-form-label">ID Number</label>
      <div class="col-sm-7">
        <fg-input type="text"
                  name="gov_id"
                  v-validate="modelValidations.gov_id"
                  :error="getError('gov_id')"
                  v-model="model.gov_id">
        </fg-input>
      </div>
      <div class="col-sm-3 label-on-right">
        <code></code>
      </div>
    </div>
    
     <div class="row">
      <label class="col-sm-2 col-form-label">ID Type</label>
      <div class="col-sm-7">
        <fg-input>
                  <el-select class="select-primary"
                             size="large"
                             placeholder=""
                             v-model="model.gov_id_type">
                    <el-option v-for="option in selects.gov_id_type"
                               class="select-danger"
                               :value="option.value"
                               :label="option.label"
                               :key="option.label">
                    </el-option>
                  </el-select>
                </fg-input>
      </div>
      <div class="col-sm-3 label-on-right">
        <code></code>
      </div>
    </div>
    
    <div class="row">
      <label class="col-sm-2 col-form-label">Email</label>
      <div class="col-sm-7">
        <fg-input type="text"
                  name="email"

                  v-model="model.email">
        </fg-input>
      </div>
      <div class="col-sm-3 label-on-right">
        <code></code>
      </div>
    </div>
    
    
    <div class="row">
      <label class="col-sm-2 col-form-label">Contact Number</label>
      <div class="col-sm-7">
        <fg-input type="text"
                  name="contact_num"
               
                  v-model="model.contact_num">
        </fg-input>
      </div>
      <div class="col-sm-3 label-on-right">
        <code></code>
      </div>
    </div>
    
    
    <div class="row">
      <label class="col-sm-2 col-form-label">Date Of Birth</label>
      <div class="col-sm-7">
       	   <div class="form-group">
              <el-date-picker 
                format="yyyy-MM-dd" value-format="yyyy-MM-dd"
              	v-model="model.dob" type="date" placeholder="Select A Date"
                              >
              </el-date-picker>
            </div>
      </div>
      <div class="col-sm-3 label-on-right">
        <code></code>
      </div>
    </div>
    
    

	
	  <div class="row">
      <label class="col-sm-2 col-form-label">Notes</label>
      <div class="col-sm-7">
       <textarea 
        		 cols="45" rows="10"
                  name="new_reso_item"
                  v-model="model.notes">
       	    </textarea>
      </div>
      <div class="col-sm-3 label-on-right">
        <code></code>
      </div>
    </div>




   

  </card>
        
        
        
<card v-if="0"  style="text-align:right;">
	 <div class="row">
      <label class="col-sm-2 col-form-label">Is Person A Representative Of A Company?</label>
      <div class="col-sm-7">
        <fg-input>
                  <el-select class="select-primary"
                             size="large"
                             placeholder=""
                               @change="onIsCompanyRepChange($event)"
                             v-model="model.is_company">
                    <el-option v-for="option in selects.is_company"
                               class="select-danger"
                               :value="option.value"
                               :label="option.label"
                               :key="option.label">
                    </el-option>
                  </el-select>
                </fg-input>
      </div>
      <div class="col-sm-3 label-on-right">
        <code>required</code>
      </div>
    </div>
	
	
	<!-- start company form -->
	<div v-if="displayCompanyForm" style="margin-top:60px;">
	
	 <div class="row" style="">
      <label class="col-sm-2 col-form-label">Company Name</label>
      <div class="col-sm-7">
        <fg-input type="text"
                  name="company_name"
                  v-model="model.company_name">
        </fg-input>
      </div>
      <div class="col-sm-3 label-on-right">
        <code></code>
      </div>
    </div>
    

    <div class="row" style="">
      <label class="col-sm-2 col-form-label">Company Registration Number</label>
      <div class="col-sm-7">
        <fg-input type="text"
                  name="company_reg_num"
                  v-model="model.company_reg_num">
        </fg-input>
      </div>
      <div class="col-sm-3 label-on-right">
        <code></code>
      </div>
    </div>
    
    
     <div class="row" style="">
      <label class="col-sm-2 col-form-label">Country Of Incorporation</label>
      <div class="col-sm-7">
        <fg-input type="text"
                  name="country"
                  v-model="model.country">
        </fg-input>
      </div>
      <div class="col-sm-3 label-on-right">
        <code></code>
      </div>
    </div>
    
    
    <div class="row" style="">
      <label class="col-sm-2 col-form-label">Company Address</label>
      <div class="col-sm-7">
        <fg-input type="text"
                  name="company_address"
                  v-model="model.company_address">
        </fg-input>
      </div>
      <div class="col-sm-3 label-on-right">
        <code></code>
      </div>
    </div>
    
    <div class="row">
      <label class="col-sm-2 col-form-label">Effective Date</label>
      <div class="col-sm-7">
       	   <div class="form-group">
              <el-date-picker 
                format="yyyy-MM-dd" value-format="yyyy-MM-dd"
              	v-model="model.effective_date" type="date" placeholder="Select A Date"
                              v-validate="modelValidations.effective_date" >
              </el-date-picker>
            </div>
      </div>
      <div class="col-sm-3 label-on-right">
        <code></code>
      </div>
    </div>
	

	</div>
	<!-- end company form -->
	
	
</card>

 <h4 style="font-weight:bold;">Actions</h4>
	<card>
	
	
 	<div  class="text-center">
      <p-button v-if="createForm"  type="info" @click.prevent="submitNewPersonForm">Submit New Person</p-button>
      <p-button v-else  type="info" @click.prevent="editPersonEntry">Edit Person</p-button>
    </div>
   </card>


  </div>
</template>
<script>
  import {DatePicker, TimeSelect, Slider, Tag, Input, Button, Select, Option} from 'element-ui'
  import {Collapse, CollapseItem, Tabs, TabPane, Card} from 'src/components/UIComponents'
  import ApiService from 'src/services/api.service'
  import swal from 'sweetalert2'
  
  
  
  export default {
    components: {
      [DatePicker.name]: DatePicker,
      [TimeSelect.name]: TimeSelect,
      [Slider.name]: Slider,
      [Tag.name]: Tag,
      [Input.name]: Input,
      [Button.name]: Button,
      [Option.name]: Option,
      [Select.name]: Select,
      TabPane,
      Tabs,
      CollapseItem,
      Collapse,
      Card
    },
    
     mounted() {
     	
     	swal.showLoading();
     	
       	let uri = this.$base_url+'/api/v1/common/get/common/person';
   
			 ApiService.get(uri).then(response => {
				
				this.variables = response.data.variables;
				this.loadCommon = true;
				if(this.loadInfo){
					swal.close();
				}
		})
			
				
     
       if(this.$route.params.pid!=0){
     		this.createForm = false;
     		
     		let uri = this.$base_url+'/api/v1/entities/get/person/'+ this.$route.params.pid;
   
			 ApiService.get(uri).then(response => {
				
				this.model = response.data.person;
			    this.loadInfo = true;
				if(this.loadCommon){
					swal.close();
				}
			
			})

       }
       else{
       		this.loadInfo = true;
       }
     	
     	 	
      
    },
    
     
    data () {
      return {
        coy:[],
        variables:[],
    	eid: this.$route.params.eid,
    	oid: this.$route.params.oid,
    	createForm: true,
    	loadCommon: false,
    	loadInfo: false,
    	displayCompanyForm: false,
        model: {
          first_name: '',
          last_name: '',
          address_1: '',
          status: 1,
          is_company: 2,
          date_appt: '',
          position:'Director',
          nationality:'SG',
          citizenship:1,
          gov_id:'',
          gov_id_type:1,
          email:'',
          contact_num:'',
          eid: this.$route.params.eid,
          company_name:'',
          company_reg_num:'',
          country:'',
          company_address:'',
          effective_date:'',
          dob:'',

        },
        modelValidations: {
          first_name: {
            required: true
          },
          last_name: {
            required: true,
          },
          address_1: {
            required: true,
          },
          status: {
          	required: true,
          },
          is_contact_person: {
            required: true,
          },
          effective_date: {
            required: true,
          },
           position: {
            required: true,
          },
          nationality: {
            required: true,
          },
          gov_id: {
            required: true,
          },
          email: {
            required: true,
            email: true
          },
          contact_num: {
            required: true,
          },
          
        },
        
        selects: {
          gov_id_type: [
            {value: 1, label: 'Government ID'},
            {value: 2, label: 'Passport'},
		   ],
		  is_company:[
            {value: 1, label: 'Yes'},
            {value: 2, label: 'No'},
		   ] 
        },
      }
    },
    methods:{
       displayErrorMessage(msg){
        		swal({
					  title: 'Error!',
					  text: msg,
					  type: 'error',
					  confirmButtonClass: 'btn btn-success btn-fill',
					  buttonsStyling: false
			 	})
        
        
        
        },
    	onIsCompanyRepChange(event){
       		if(this.model.is_company == 1){

       			this.displayCompanyForm = true;
       		}
       		else{
       			this.displayCompanyForm = false;
       		}
       
       },
 
       getError(fieldName) {
        return this.errors.first(fieldName)
      },
      submitNewPersonForm() {
        this.$validator.validateAll().then(isValid => {
          if (!isValid) {
    		
  		  } else {
    		let uri = this.$base_url+'/api/v1/entities/create_person';
      		ApiService.post(uri, this.model).then(response => {
      				if(!response.data.person){
      					this.displayErrorMessage(response.data.message);
      				}
      				else{
         				this.$router.push( '/people')
         			}
         		
     		 })
  		  }
        
         
        })
      },///end validate+create
      editPersonEntry() {
        this.$validator.validateAll().then(isValid => {
          if (!isValid) {
    		
  		  } else {
    		let uri = this.$base_url+'/api/v1/entities/edit_person/'+this.$route.params.pid;
      		ApiService.post(uri, this.model).then(response => {
         			if(!response.data.person){
      					this.displayErrorMessage(response.data.message);
      				}
      				else{
         				this.$router.push( '/people')
         			}
         		
     		 })
  		  }
        
         
        })
      },///end validate+edit
      
      
      
    },

    
  }
</script>
<style>
  .extended-forms .el-select {
    width: 100%;
  }
  
  .el-date-editor .el-input__inner{
  	padding-left:36px!important;
  }
</style>


